import { fetcherAmplify } from 'src/business/Libraries/Fetcher';
import ComplianceRepositoryImpl from './repository/ComplianceRepositoryImpl';
import ComplianceServiceImpl from './service/ComplianceServiceImpl';

const complianceRepository = new ComplianceRepositoryImpl(fetcherAmplify);
export const complianceService = new ComplianceServiceImpl(
  complianceRepository,
);
